// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"29d9c28e","453":"7b82410e"}[chunkId] + ".chunk.js";
};